<template>
    <hts-tooltip>
        <template #reference>
            <hts-icons
                svg="pin-dark"
                class-name="h-12 w-12 cursor-pointer transition-all hover:text-gray-500"
                :class="{
                    '!fill-gray-700': showJourney,
                    '!fill-gray-300': !showJourney
                }"
                @click="change" />
        </template>
        <span>
            {{ label }}
        </span>
    </hts-tooltip>
</template>
<script setup lang="ts">
import Direction from './direction'

const props = defineProps({
  label: {
    type: String,
    default: 'Ẩn/hiện danh sách chặng cần điều phối'
  }
})

const { map } = $store()

const showJourney = computed(() => {
  if (!map) {
    return
  }

  return map.getShowJourney
})

const change = () => {
  if (!map) {
    return
  }

  map.setShowJourney(!showJourney.value)
}
</script>
